// routeHistory.js
'use strict';
import { fromJS } from 'immutable';
import {
  PUSH_ROUTE_HISTORY,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
  RESTORE_ROUTE_HISTORY,
  CLEAR_ROUTE_HISTORY,
} from '../ActionTypes.js';

export const defaultState = fromJS({
  stack: [],
});

/**
 * Route history.
 * @module reducer/routeHistory
 */
const routeHistory = (state = defaultState, action) => {
  switch (action.type) {
    case PUSH_ROUTE_HISTORY:
      return _PUSH_ROUTE_HISTORY(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    case RESTORE_ROUTE_HISTORY:
      return _RESTORE_ROUTE_HISTORY(action.payload)(state);
    case CLEAR_ROUTE_HISTORY:
      return _CLEAR_ROUTE_HISTORY(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Push history
 * @kind reducer/actionType
 * @name PUSH_ROUTE_HISTORY
 * @param {string} {href} - window location href
 * @return {Immutable.Map} New state
 */
const _PUSH_ROUTE_HISTORY = href => state => {
  let stack = state.getIn(['stack']);
  if (stack.get(-1) !== href) {
    stack = state.getIn(['stack']).push(href);
  }
  return state.setIn(['stack'], stack);
};

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

/**
 * Restore route history
 * @kind reducer/actionType
 * @name RESTORE_ROUTE_HISTORY
 * @param {object} routeHistoryData - route history data
 * @return {Immutable.Map} New state
 */
const _RESTORE_ROUTE_HISTORY = routeHistoryData => state => {
  return state.mergeDeep(routeHistoryData);
};

/**
 * Clear route history
 * @kind reducer/actionType
 * @name CLEAR_ROUTE_HISTORY
 * @return {Immutable.Map} New state
 */
const _CLEAR_ROUTE_HISTORY = () => () => {
  return defaultState;
};

export default routeHistory;
